import { render } from "./icon.vue?vue&type=template&id=6eb935bd"
import script from "./icon.vue?vue&type=script&setup=true&lang=js"
export * from "./icon.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6eb935bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6eb935bd', __exports__)) {
    console.log('reload')
    api.reload('6eb935bd', __exports__)
  }
  
  module.hot.accept("./icon.vue?vue&type=template&id=6eb935bd", () => {
    console.log('re-render')
    api.rerender('6eb935bd', render)
  })

}


export default __exports__